// extracted by mini-css-extract-plugin
export default {"container":"SubscriptionForm_container__Qde4o","formGroup":"SubscriptionForm_formGroup__5srL6"};